// A card counts as FSRS-"mastered" once the review interval assigned at its last
// review (its `scheduledDays` — how far out that review pushed the next one) is
// more than this many days. Shared so the deck buckets, the morpheme button
// stage and the learning-progress panel all agree on what "mastered" means.
//
// This is interval-at-last-review based, NOT "how much of the interval is left
// today": a card the algorithm pushed three months out stays mastered right up
// until the next time it's actually reviewed.
export const MASTERED_INTERVAL_DAYS = 90;

/**
 * Whether an FSRS review interval (in days, the card's `scheduledDays`) reaches
 * the mastered cutoff: at least {@link MASTERED_INTERVAL_DAYS} days.
 */
export function isFsrsIntervalMastered(scheduledDays: number): boolean {
  return scheduledDays >= MASTERED_INTERVAL_DAYS;
}

/**
 * The unified mastery predicate for a single card. A card is mastered when the
 * user has manually marked it (`manuallyMasteredAt` set) OR the FSRS interval
 * assigned at its last review reached the mastered cutoff. A never-reviewed card
 * (`lastReview` null) is never naturally mastered. Manual mastery is fully
 * reversible by clearing `manuallyMasteredAt`.
 */
export function isUserCardMastered({
  lastReview,
  manuallyMasteredAt,
  scheduledDays,
}: {
  lastReview: string | null | undefined;
  manuallyMasteredAt: string | null | undefined;
  scheduledDays: number | null | undefined;
}): boolean {
  if (manuallyMasteredAt != null) {
    return true;
  }
  if (lastReview == null || scheduledDays == null) {
    return false;
  }
  return isFsrsIntervalMastered(scheduledDays);
}
